import { call, put, takeLatest, select, all, takeEvery, fork } from "redux-saga/effects";
import constantService from '../../services/constant-service';

import { convertArrayToObject, mockResponse } from "../../utils/common-util";
import {
  getConstants,
  getConstantsSuccess,
  getConstantsFailure,
} from "../reducer/master-reducer";


const getConstantsSaga = function* () {
  try {
    const response = yield call(constantService.getConstants);
    console.log(response);
   
    // yield put(getConstantsSuccess({ errorConst }));
  } catch (error) {
    yield put(getConstantsFailure(error));
  }
};



const saga = [
  takeLatest(getConstants.type, getConstantsSaga),
];

export default saga;
